"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSysCodeInfoView = instanceOfSysCodeInfoView;
exports.SysCodeInfoViewFromJSON = SysCodeInfoViewFromJSON;
exports.SysCodeInfoViewFromJSONTyped = SysCodeInfoViewFromJSONTyped;
exports.SysCodeInfoViewToJSON = SysCodeInfoViewToJSON;
exports.SysCodeInfoViewToJSONTyped = SysCodeInfoViewToJSONTyped;
/**
 * Check if a given object implements the SysCodeInfoView interface.
 */
function instanceOfSysCodeInfoView(value) {
    if (!('sysCode' in value) || value['sysCode'] === undefined)
        return false;
    if (!('sysName' in value) || value['sysName'] === undefined)
        return false;
    if (!('sysAname' in value) || value['sysAname'] === undefined)
        return false;
    return true;
}
function SysCodeInfoViewFromJSON(json) {
    return SysCodeInfoViewFromJSONTyped(json, false);
}
function SysCodeInfoViewFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sysCode': json['sysCode'],
        'sysName': json['sysName'],
        'sysGroup': json['sysGroup'] == null ? undefined : json['sysGroup'],
        'sysDbIp': json['sysDbIp'] == null ? undefined : json['sysDbIp'],
        'sysApIp': json['sysApIp'] == null ? undefined : json['sysApIp'],
        'sysAname': json['sysAname'],
        'sysLoginUrl': json['sysLoginUrl'] == null ? undefined : json['sysLoginUrl'],
        'sysLoginUid': json['sysLoginUid'] == null ? undefined : json['sysLoginUid'],
        'sysLoginPwd': json['sysLoginPwd'] == null ? undefined : json['sysLoginPwd'],
        'sysImgUrl': json['sysImgUrl'] == null ? undefined : json['sysImgUrl'],
    };
}
function SysCodeInfoViewToJSON(json) {
    return SysCodeInfoViewToJSONTyped(json, false);
}
function SysCodeInfoViewToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'sysCode': value['sysCode'],
        'sysName': value['sysName'],
        'sysGroup': value['sysGroup'],
        'sysDbIp': value['sysDbIp'],
        'sysApIp': value['sysApIp'],
        'sysAname': value['sysAname'],
        'sysLoginUrl': value['sysLoginUrl'],
        'sysLoginUid': value['sysLoginUid'],
        'sysLoginPwd': value['sysLoginPwd'],
        'sysImgUrl': value['sysImgUrl'],
    };
}
